import { find, register } from '../../../../Javascript/Sysmex/Utils'

const componentPrefix = 'sysmexAtomPassword'

const Password = el => {
  const input = find('input', el)

  const toggleShowHidePassword = find(`.${componentPrefix}_toggleShowHidePassword`, el)

  const labels = toggleShowHidePassword.dataset

  toggleShowHidePassword.addEventListener('click', (e) => {
    if (input.type === 'password') {
      input.type = 'text'
      e.target.innerText = labels.hide
    } else {
      input.type = 'password'
      e.target.innerText = labels.show
    }
  })
}

register('Password', Password)
